import { render } from "./ThinFrame.vue?vue&type=template&id=50922c8e&scoped=true&ts=true"
import script from "./ThinFrame.vue?vue&type=script&lang=ts"
export * from "./ThinFrame.vue?vue&type=script&lang=ts"

import "./ThinFrame.vue?vue&type=style&index=0&id=50922c8e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50922c8e"]])

export default __exports__